export default __webpack_public_path__ + "static/media/tufan5.54a25971.jpg";